import { Directive } from '@angular/core';
import type { FilePickerTemplateContext } from './models';

@Directive({
    selector: 'ng-template[qpxFilePickerTpl]',
})
export class FilePickerTemplate {
    static ngTemplateContextGuard(
        _dir: FilePickerTemplate,
        _ctx: unknown
    ): _ctx is FilePickerTemplateContext {
        return true;
    }
}
